import type { FieldRole } from '../../model/field-catalog';

export const ROLE_LABELS: Readonly<Record<FieldRole, string>> = {
  categorical: 'Categorica',
  temporal: 'Temporal',
  geographic: 'Geografica',
  identifier: 'Identificador',
  measure: 'Medida',
};

export const DATA_TYPE_LABELS: Readonly<Record<string, string>> = {
  string: 'Texto',
  integer: 'Entero',
  decimal: 'Decimal',
  date: 'Fecha',
  datetime: 'Fecha y hora',
  boolean: 'Booleano',
};
